import { Event, events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { reduceProject } from "../../common/project";
import { initialState } from "./initialState";
import { handleRequest } from "./retrieveZoneProjectsRequested";
import { handleSuccess } from "./retrieveZoneProjectsSucceeded";
import { handleFailure } from "./retrieveZoneProjectsFailed";
import { handleProjectCreation } from "./createProjectSucceeded";
import { handleProjectsTransfer } from "./transferProjectsSucceeded";
import { handleProjectRemoval } from "./removeProjectSucceeded";
import { handleListEdition } from "./editListSucceeded";
import { handleUseProjectModel } from "./useProjectModelSucceeded";
import { handleDuplicateProject } from "./useDuplicateProjectSucceeded";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

function propagateEvent(state = initialState, event: Event): State {
  return state.map((req) => ({
    ...req,
    projects: req.projects.map((project) => reduceProject(project, event)),
  }));
}

const reduceState = resetState(
  initialState,
  createStateReducer(
    initialState,
    {
      [events.retrieveZoneProjectsRequested]: handleRequest,
      [events.retrieveZoneProjectsSucceeded]: handleSuccess,
      [events.retrieveZoneProjectsFailed]: handleFailure,
      [events.createProjectSucceeded]: handleProjectCreation,
      [events.transferProjectsSucceeded]: handleProjectsTransfer,
      [events.removeProjectSucceeded]: handleProjectRemoval,
      [events.editListSucceeded]: handleListEdition,
      [events.useProjectModelSucceeded]: handleUseProjectModel,
      [events.duplicateProjectSucceeded]: handleDuplicateProject,
    },
    propagateEvent,
  ),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
